
import { useQuery } from "@tanstack/react-query"
import { supabase } from "@/integrations/supabase/client"
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { UseFormReturn } from "react-hook-form"
import { RegistrationFormData } from "@/types/auth"

type RoleFieldsProps = {
  form: UseFormReturn<RegistrationFormData>
  adminCreating?: boolean
}

export function RoleFields({ form, adminCreating = false }: RoleFieldsProps) {
  const { data: mayors } = useQuery({
    queryKey: ["mayors"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("municipalities")
        .select("mayor_name, name")
        .order("name")
      
      if (error) {
        console.error("Erro ao carregar prefeitos:", error)
        return []
      }
      
      return data || []
    },
  })

  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="role"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Função</FormLabel>
            <Select 
              onValueChange={field.onChange} 
              defaultValue={field.value}
            >
              <SelectTrigger>
                <SelectValue placeholder="Selecione uma função" />
              </SelectTrigger>
              <SelectContent>
                {adminCreating && (
                  <SelectItem value="admin">Administrador</SelectItem>
                )}
                <SelectItem value="vereador">Vereador</SelectItem>
                <SelectItem value="vereador-presidente da câmara">Vereador - Presidente da Câmara</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="prefeito"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Prefeito</FormLabel>
            <Select onValueChange={field.onChange} value={field.value || "selecione"}>
              <SelectTrigger>
                <SelectValue placeholder="Selecione o prefeito" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="selecione" disabled>Selecione o prefeito</SelectItem>
                {mayors?.map((mayor) => (
                  <SelectItem key={mayor.mayor_name} value={mayor.mayor_name}>
                    {mayor.mayor_name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  )
}
